import { forwardRef, type HTMLAttributes } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils.ts'

const badgeStyles = cva(
  'inline-flex items-center font-medium rounded-full border whitespace-nowrap',
  {
    variants: {
      variant: {
        neutral: 'bg-gray-100 text-gray-700 border-gray-200',
        info: 'bg-blue-50 text-blue-700 border-blue-200',
        success: 'bg-green-50 text-green-700 border-green-200',
        warning: 'bg-amber-50 text-amber-700 border-amber-200',
        danger: 'bg-red-50 text-red-700 border-red-200',
        brand: 'bg-brand-50 text-brand-700 border-brand-200',
        accent: 'bg-accent-50 text-accent-700 border-accent-200',
      },
      size: {
        sm: 'text-caption px-1.5 py-0.5 gap-1',
        md: 'text-small px-2 py-0.5 gap-1',
        lg: 'text-body px-2.5 py-1 gap-1.5',
      },
    },
    defaultVariants: {
      variant: 'neutral',
      size: 'md',
    },
  },
)

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeStyles> {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, size, ...props }, ref) => (
    <span ref={ref} className={cn(badgeStyles({ variant, size }), className)} {...props} />
  ),
)
Badge.displayName = 'Badge'
